type ContactUpdateFields = Record<string, unknown> & {
  companyId?: number | null;
  companyEmail?: string | null;
  role?: string | null;
};

/**
 * Keep prior-employer details in history when a contact changes primary
 * company. Only values explicitly edited in the same form belong to the new
 * relationship.
 */
export function buildContactUpdatePayload<T extends ContactUpdateFields>(
  data: T,
  previousCompanyId: number | null,
  nextCompanyId: number | null,
  dirtyFields: { companyEmail?: boolean; role?: boolean },
): T & { companyId: number | null } {
  const payload: ContactUpdateFields & Record<string, unknown> = {
    ...data,
    companyId: nextCompanyId,
  };

  if (previousCompanyId !== nextCompanyId) {
    // Omission distinguishes "the email field was untouched" from an explicit
    // clear. The canonical writer can then preserve a legacy-only replacement
    // that predates contact_emails without assigning it to the old employer.
    if (!dirtyFields.companyEmail) delete payload.companyEmail;
    if (!dirtyFields.role) payload.role = null;
  }

  return payload as T & { companyId: number | null };
}
